import firebase from "firebase";


const secondaryAppConfig = {
  apiKey: "AIzaSyAFQtcUfFsFin46zZ9BOzRsXIih5_QU7Q4",
  authDomain: "rage-fan-beta.firebaseapp.com",
  projectId: "rage-fan-beta",
  storageBucket: "rage-fan-beta.appspot.com",
  messagingSenderId: "486855769262",
  appId: "1:486855769262:web:d17b239ef3ecb9565d013f",
  measurementId: "G-XGPLX8LM68",
};
const secondaryApp = firebase.initializeApp(secondaryAppConfig, "secondary");
const secondaryDatabase = secondaryApp.firestore();


// module.exports ={
//     secondaryDatabase
// }

export {
  secondaryDatabase
} 